<template>
  <div class="bg-sub-search">
    <div class="container header-page">
      <mdb-card class="card-profile" v-if="typelogin == 'local'">
        <mdb-card-body class="card-body-profile">
          <div class="header-profile">
            <h2 class="text-center">เปลี่ยนรหัสผ่าน</h2>
            <!--p class="alert-changepass" id="alertxxx" v-show="alertChangepass">เปลี่ยนรหัสผ่านเรียบร้อยแล้ว !</p-->
            <div class="form-profile">
              <form ref="ChangePass">

                <div v-if="alertChangepass" class="alert alert-success alert-dismissible fade show" role="alert">
                  <span class="text-alert">เปลี่ยนรหัสผ่านเรียบร้อยแล้ว !</span>
                <button type="button" @click="alertChangepass=false" class="close" data-dismiss="alert" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
                </div>
                <div v-if="alertwrong" class="alert alert-danger alert-dismissible fade show" role="alert">
                  <span class="text-alert">รหัสผ่านเก่าไม่ถูกต้อง !</span>
                <button type="button" @click="alertwrong=false" class="close" data-dismiss="alert" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
                </div>

                <div class="text-box">
                  <label class="label-input">รหัสผ่านเก่า</label>
                  <input type="password" v-validate="{ required: true, min: 6 }" name="OldPassword" class="form-control" v-model="ChangeOldInput"  placeholder="Old Password" label="อีเมล์" :class="{ 'is-invalid': errors.has('OldPassword') }"/>
                  <span class="help is-danger">{{ errors.first('OldPassword') }}</span>
                </div>

                <div class="text-box">
                  <label class="label-input">รหัสผ่านใหม่</label>
                  <input type="password" v-validate="{ required: true, min: 6 }" ref="password" name="NewPassword" class="form-control" v-model="ChangeInput"  placeholder="New Password" label="อีเมล์" :class="{ 'is-invalid': errors.has('Password') }"/>
                  <span class="help is-danger">{{ errors.first('Password') }}</span>
                </div>

                <div class="text-box">
                  <label class="label-input">ยืนยันรหัสผ่านใหม่</label>
                  <input type="password" v-validate="'required|confirmed:password'" name="Confirm Password" class="form-control" v-model="ChangeInputCon" placeholder="Confirm Password" label="อีเมล์" :class="{ 'is-invalid': errors.has('Confirm Password') }"/>
                  <span class="help is-danger">{{ errors.first('Confirm Password') }}</span>
                </div>
              </form>
            </div>

          </div>
          <div class="text-center footer-card-profile">
            <btn color="primary" @click="ChangePassword()" :disabled="errors.any() || ChangeInput == '' ">บันทึกการแก้ไข</btn>
          </div>

        </mdb-card-body>
  </mdb-card>

  <mdb-card class="card-profile" v-if="typelogin == 'ad'">
    <mdb-card-body class="card-body-profile1">
      <div class="header-profile">
        <h2 class="text-center">เปลี่ยนรหัสผ่าน</h2>
        <!--p class="alert-changepass" id="alertxxx" v-show="alertChangepass">เปลี่ยนรหัสผ่านเรียบร้อยแล้ว !</p-->
        <div class="ad-check">
          <p >ขณะนี้ Email ของท่านที่กำลังใช้งานอยู่เป็น Email ของทางกองทัพ หากต้องการเปลี่ยนรหัสผ่านกรุณาติดต่อทางกองทัพหรือเข้าระบบของกองทัพ เพื่อเปลี่ยนรหัสผ่าน</p>
        </div>
      </div>
    </mdb-card-body>
  </mdb-card>
    </div>
  </div>

</template>

<script>
import config from '../config';
import axios from 'axios';
const Host = config.app.Host;
import { mdbCarousel, mdbCarouselItem, mdbCard, mdbCardImage, mdbCardBody, mdbCardTitle, mdbCardText, mdbBtn, mdbInput, Btn } from 'mdbvue';

export default {
  name: 'ChangePassPage',
  components: {
    mdbCarousel,
    mdbCarouselItem,
    mdbCard,
    mdbCardImage,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbBtn,
    Btn,
    mdbInput,
    config
  },
  data() {
    return {
      ChangeInput: '',
      ChangeOldInput: '',
      ChangeInputCon: '',
      alertChangepass: false,
      alertwrong: false,
      typelogin: ''
    };
  },
  mounted() {
    this.ToggleLogin();
    localStorage.pincode = '';
    this.Session();
    this.typelogin = 'ad';
  },
  methods: {
    Session() {
      let APIgetSession = Host + '/api/v1/member/session';
      axios.post(APIgetSession , {
        token: localStorage.token
      }).then(response => {
        if (response.data.code !== '200') {
          localStorage.emailfront = '';
          localStorage.token = '';
          localStorage.auth = 'false';
        }
      });
    },
    ToggleLogin() {
      if (localStorage.auth == 'false' || !localStorage.auth) {
        this.$router.push('/');
      }
      this.modalLogin = true;
    },
    ChangePassword() {
      let APIgetChangepass = Host + '/api/v1/member/password';
      var self = this;
      axios.post(APIgetChangepass , {
        email: localStorage.emailfront,
        password: this.ChangeOldInput,
        newpassword: this.ChangeInput
      }).then(response => {
        if (response.data.code == '200') {
          this.ChangeInput = '';
          this.ChangeOldInput = '';
          this.ChangeInputCon = '';
          this.$nextTick(() => {
            this.$validator.reset();
          });
          this.alertChangepass = true;
          setTimeout(function () {
            self.alertChangepass = false;
          }, 2000);
        } else {
          this.alertwrong = true;
          setTimeout(function () {
            self.alertwrong = false;
          }, 2000);
        }
      });
    }
  }
};
</script>

<style lang="css">

.fade-enter-active, .fade-leave-active {
   transition: opacity .5s
 }
 .fade-enter, .fade-leave-to  {
   opacity: 0
 }

.ad-check {
  text-indent: 50px;
}
</style>
